$(function () {
    'use strict';

    //////////////////////////////////////////////////////////////////////////////////////
    //
    // V A R I A B L E S
    //
    //////////////////////////////////////////////////////////////////////////////////////

    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $(document)
        },
        param = {
            winW: window.innerWidth || $el.window.width(),
            winH: window.innerHeight || $el.window.height(),
            docW: $el.document.outerWidth(),
            docH: $el.document.outerHeight(),
            switch_flg: '',
            flkty: ''
        };

    document.addEventListener('lazybeforeunveil', function(e){
        var bg = e.target.getAttribute('data-bg');
        if(bg){
            e.target.style.backgroundImage = 'url(' + bg + ')';
        }
    });



    //*サーチtoggle
    $fn.searchClick = function(){
        $('.search-box').on('click',function () {

           if($('.l-Search').hasClass('is-active') === false){
               if($('.l-About').hasClass('is-active') === true) {
                   $('.l-About').removeClass('is-active');
                   $('.l-header .toggle').removeClass('is-active');
               }
               $('.l-Search').addClass('is-active');
               $('.search-box').addClass('is-active');
           }else{
               $('.l-Search').removeClass('is-active');
               $('.search-box').removeClass('is-active');

           }
        });
    };
    if($('.page-load-status').length) {
        var $container = $('.content--alternate').infiniteScroll({
            append: '.content__item.content__item--wide',
            path: '.next_posts_link a',
            hideNav: '.next_posts_link',
            button: '.view-more-button',
            scrollThreshold: 100,
            status: '.page-load-status',
            history: 'false',
        });
    }

    //*abouttoggle

    $fn.aboutClick = function(){
        $('.toggle').on('click',function () {
            if($('.l-About').hasClass('is-active') === false){
                if($('.l-Search').hasClass('is-active') === true){
                    $('.l-Search').removeClass('is-active');
                    $('.search-box').removeClass('is-active');
                }
                $('.l-About').scrollTop(0);

                $('.l-About').addClass('is-active');
                $('.l-header .toggle').addClass('is-active');
            }else{
                $('.l-About').removeClass('is-active');
                $('.l-header .toggle').removeClass('is-active');
            }
        });
    };

    $fn.aboutClick();
    $fn.searchClick();


    $(window).resize(function() {
        param = {
            winW: window.innerWidth || $el.window.width(),
            winH: window.innerHeight || $el.window.height(),
            docW: $el.document.outerWidth(),
            docH: $el.document.outerHeight(),
            switch_flg: '',
            flkty: ''
        };
    });

    //scrolleffect
    $el.window.on('scroll touchmove', function () {
        param.scrollpos = amount;

        // $fn.scrollparallax();
        var amount = $(this).scrollTop();
        $fn.scrollNavi(amount);
        clearTimeout( param.timer );
        param.timer = setTimeout(function() {
            param.scrollpos = amount;
        }, 10 );
    });
    $fn.scrollNavi = function (scroll_amount) {
        var openFlag = false;
        $('.hidden-menu .category-box').each(function () {
            if($(this).attr('class').indexOf('open') !== -1){
                openFlag = true;
            }
        });
        if(scroll_amount > 100 && !openFlag){
            $('.l-news').addClass('is_active');
        }else if(scroll_amount <= 100 && !openFlag){
            $('.l-news').removeClass('is_active');
        }
    };

    //部屋search
    function zeroPadding(num,length){
        return ('0000000000' + num).slice(-length);
    }

    $('#js-room-num').focusin(function () {
        $('.not-found').css('display','none');
    });
    $('.button-search').on('click',function () {
        if($('#js-room-num').val() !=="") {
            var url = $(this).attr('data-url');
            var num = $('#js-room-num').val();
            num = zeroPadding(num, 3);

            url = url + num + '/';

            $fn.urlCheck(url);
        }
    });
    $fn.urlCheck = function($url) {
        $.ajax({
            url: $url,
            type: 'GET'
        }).done(function() {
            location.href = $url;
        }).fail(function() {
            $('.not-found').css('display','block');
            $('#js-room-num').val('');

        });
    }
});

$(window).on('load',function() {
    var $fn = {},
        $el = {
            window       : $(window),
            html         : $('html'),
            body         : $('body'),
            document     : $(document)
        },
        param = {
            winW        : window.innerWidth || $el.window.width(),
            winH        : window.innerHeight || $el.window.height(),
            docW        : $el.document.outerWidth(),
            docH        : $el.document.outerHeight(),
            linkName    : '',
            dataName    : '',
            switch_flg  : '',
            controller  : '',
            photoNumPath : '',
            photoLen : 1,
            photoNum : '',
            flkty   :'',
            scene  : ''
        };



    //順番入れ替え
    $fn.indexSlide_order = function() {
        var $obj = $('.index-carousel li');
        var count = $obj.length;
        var index = count-1;
        $obj.each(function () {
        });

        var indexSlide_change = function() {
            if(index < 0) {
                index = count-1;
            }
            $('.index-carousel li:eq('+ index +')').css('z-index',0);
            index = index-1;
            $('.index-carousel li:eq('+ index +')').css('z-index',1);
        };

        setInterval(indexSlide_change, 2000);

    };
    $fn.indexSlider = function() {
        if ($('.main-carousel').length) {
            // $fn.mainimgSize();
            var carousel = document.querySelector('.main-carousel');
            param.flkty = new Flickity(carousel, {
                // fade: true,
                percentPosition: false,
                autoPlay: 3000,
                friction: .4,
                contain: true,
                prevNextButtons: false,
                pauseAutoPlayOnHover: true,
                draggable: false,
                pageDots: true,
                wrapAround: true
            });
        }
    };
    $fn.indexSlide_order();







});